'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

/**
 * Soft-refreshes the radar on an interval so the board stays live without a full page reload
 * (router.refresh re-runs the server component and reconciles the DOM). Free viewers see a delayed
 * board anyway, but the refresh still advances prices and matures the newest flags into view.
 */
export default function AutoRefresh({ seconds = 60 }: { seconds?: number }) {
  const router = useRouter();
  useEffect(() => {
    const ms = Math.max(15, seconds) * 1000;
    const id = setInterval(() => router.refresh(), ms);
    return () => clearInterval(id);
  }, [router, seconds]);
  return null;
}
